import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface RelatedPartyDisclosureInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function RelatedPartyDisclosureInternalControls({ onBack, setActiveSection, controlsListSection }: RelatedPartyDisclosureInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Related Party Disclosure"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
